module.exports = __webpack_public_path__ + "static/media/apple.466d7063.png";